import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import * as React from "react";
export var useImageUploaderState = function(onFileUpload) {
    var _React_useState = _sliced_to_array(React.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(undefined), 2), errorMessage = _React_useState1[0], setErrorMessage = _React_useState1[1];
    var clearErrorMessage = function() {
        setErrorMessage(undefined);
    };
    var handleImageUpload = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(file) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        clearErrorMessage();
                        return [
                            4,
                            onFileUpload(file)
                        ];
                    case 1:
                        _state.sent();
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleImageUpload(file) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        loading: loading,
        errorMessage: errorMessage,
        setErrorMessage: setErrorMessage,
        clearErrorMessage: clearErrorMessage,
        handleImageUpload: handleImageUpload
    };
};
